import { c as _c } from "react/compiler-runtime";
import type { ProfileActivityLogSocialVerificationPostEdit } from "@/entities/IProfile";
import { PROFILE_ACTIVITY_LOG_ACTION_STR } from "@/entities/IProfile";
import SocialStatementIcon from "@/components/user/utils/icons/SocialStatementIcon";
import ProfileActivityLogItemAction from "./utils/ProfileActivityLogItemAction";
import ProfileActivityLogItemValueWithCopy from "./utils/ProfileActivityLogItemValueWithCopy";
export default function ProfileActivityLogSocialMediaVerificationPost(t0) {
  const $ = _c(11);
  const {
    log
  } = t0;
  const t1 = PROFILE_ACTIVITY_LOG_ACTION_STR[log.contents.action];
  let t2;
  if ($[0] !== t1) {
    t2 = <ProfileActivityLogItemAction action={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-whitespace-nowrap tw-text-sm lg:tw-text-base tw-text-iron-300 tw-font-medium">social media verification post</span>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== log.contents.statement.statement_type) {
    t4 = <div className="tw-flex tw-items-center tw-flex-shrink-0 tw-h-5 tw-w-5 tw-text-iron-200"><SocialStatementIcon statementType={log.contents.statement.statement_type} /></div>;
    $[3] = log.contents.statement.statement_type;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== log.contents.statement.statement_value) {
    t5 = <ProfileActivityLogItemValueWithCopy title={log.contents.statement.statement_value} value={log.contents.statement.statement_value} />;
    $[5] = log.contents.statement.statement_value;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t4 || $[9] !== t5) {
    t6 = <>{t2}{t3}{t4}{t5}</>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}